module.exports = __webpack_public_path__ + "static/media/header-logo.8f46539f.svg";